export default __webpack_public_path__ + "static/media/MiniTape_SideA_10_Interview-Walter-aus-Heitenried.66f02d9f.mp3";